
import GeneracionLecturaBLL from '../BLL/GeneracionLecturaBLL';
import PaqueteTodoFacilController from './PaqueteTodoFacilController';
import { getDataBase } from '../db';
import MedidorAnormalidadDAL from '../DAL/MedidorAnormalidadDAL';
import CategoriaDAL from '../DAL/CategoriaDAL';
import GeneracionLecturaDAL from '../DAL/GeneracionLecturaDAL';
import GeneracionLecturaFotoDAL from '@/DAL/GeneracionLecturaFotoDAL';

export default class GeneracionLecturaController{

    async DO_LecturarNormal(toParametros){
        const loPaquete = new PaqueteTodoFacilController();
        try {
           // $loTrayectoria          = new TrayectoriaController; //metodo GuardarUbicacion
            const loGeneracionLecturaBLL = new GeneracionLecturaBLL();
            
            let loGeneracionLectura = toParametros.GeneracionLectura;
            const loClienteDatos = toParametros.ClienteDatos;
            
            if (loGeneracionLectura.tnMedidorAnormalidad != 0) {
                //validacion para anormalidaddes
                const laMedidorAnormalidadDAL = new MedidorAnormalidadDAL();
                const loAnormalidad = await laMedidorAnormalidadDAL.GetRecDt(loGeneracionLectura.tnMedidorAnormalidad, loGeneracionLectura.DataBaseAlias);
        
                if (loAnormalidad[0].Inspeccion == 1) {
                    let laResult = {};
                    // Asignar valores directamente al objeto
                    laResult['Error'] = 0;
                    laResult['tnGlosa'] = false;
                    laResult['imageEnviar'] = false;

                    if (loGeneracionLectura['tnGlosa'] == '') {
                        laResult['Error'] = 9999;
                        laResult['tnGlosa'] = true;
                    }

                    // verificar si ya hay imagenes en la base de datos
                    if (toParametros.imageEnviar.length == 0) {
                        //buscar en la base de datos
                        laResult['Error'] = 9999;
                        laResult['imageEnviar'] =  true;
                    }

                    if (laResult['Error'] == 9999 ) {
                        loPaquete.values = laResult;
                        return loPaquete;
                    }
                }
            }

            if ( loGeneracionLectura.tnMedidor == 0){
               
               
                const loCategoriaDAL = new CategoriaDAL();
                let loCategoria = await loCategoriaDAL.GetConsumoMinimo(loGeneracionLectura.tnCategoria, loGeneracionLectura.DataBaseAlias);
           
                const lnConsumo     = loCategoria[0].ConsumoMinimo;
                const LecturaActual = lnConsumo;
                const Consumo       = lnConsumo;
                const lnMedidorAnormalidad = 0;
                const lnMedidorAnormalidad2 = 0; // TODO : implementacion de la variable para la segunda anormalidad
                const lnTipoConsumo = 1;


                // GeneracionLecturaDAL::ActualizarLecturaSinMedidorDAL($request->tnGeneracionFactura, $request->tnCliente, $LecturaActual, $Consumo, $lnMedidorAnormalidad, $request->DataBaseAlias);
                const generacionLecturaDAL = new GeneracionLecturaDAL();
                await generacionLecturaDAL.ActualizarLecturaSinMedidorDAL(loGeneracionLectura.tnGeneracionFactura, loGeneracionLectura.tnCliente, LecturaActual, Consumo, lnMedidorAnormalidad, loGeneracionLectura.DataBaseAlias);


                const loResultGenracion = await loGeneracionLecturaBLL.ActualizarLecturaMovilSinMedidor(
                    loGeneracionLectura.tnGeneracionFactura,
                    loGeneracionLectura.tnCliente,
                    loGeneracionLectura.tnCategoria,
                    lnTipoConsumo, /*$lnMedidorAnormalidad*/
                    lnMedidorAnormalidad2,
                    loGeneracionLectura.DataBaseAlias
                );

                if (loResultGenracion) {
                    loGeneracionLectura.Error = 2000;
                }else{
                    loPaquete.error = 1;
                    loPaquete.status = 0;
                    loPaquete.message = "Error al lecturar";
                    loPaquete.values = loGeneracionLectura;
                    return loPaquete;
                }
            
        

            }else{
                loGeneracionLectura = await loGeneracionLecturaBLL.ModificarYValidarLectura(loGeneracionLectura, loClienteDatos );
            }
      
            if( loGeneracionLectura.Error == 2000){
                loPaquete.values = loGeneracionLectura;

                // subir imaganes 
                const laImagenes = toParametros.imageEnviar;
                if (laImagenes.length > 0) {
                  
                    const loResult = await GeneracionLecturaFotoDAL.imagenStore(
                        laImagenes, 
                        toParametros.GeneracionLectura.tnGeneracionFactura, 
                        toParametros.GeneracionLectura.tnCobro, 
                        toParametros.GeneracionLectura.tnCodigoUbicacion, 
                        toParametros.GeneracionLectura.tnCliente,
                        toParametros.GeneracionLectura.EmpresaNombre,
                        toParametros.GeneracionLectura.DataBaseAlias,
                        toParametros.imagenesSizes
                    );

                 
                    console.log('loResult', loResult);
                    if (loResult == 0) {
                        loPaquete.error = 1;
                        loPaquete.status = 0;
                        loPaquete.message = "Error: No se pudo subir las imagenes, intenta de nuevo";
                        loPaquete.values = null;
                      
                    }

                }

            }else{
                loPaquete.error = 1;
                loPaquete.status = 0;
                loPaquete.message = "Error al lecturar";
                loPaquete.values = loGeneracionLectura;
            }

            return loPaquete;

        } catch (error) {
            loPaquete.error = 1;
            loPaquete.status = 0;
            loPaquete.message = "Error: Ocurrio un error inecperado, contacte con soporte";
            loPaquete.values = null;
            return loPaquete;
        }
    }


    
    
}